import { createFileRoute, Outlet } from '@tanstack/react-router'
import { teamsListSearchSchema } from '@/features/teams/team-list-search'

/** Search lives on the layout so list filters survive navigation to `/teams/$uuid`. */
export const Route = createFileRoute('/_authed/teams')({
  validateSearch: teamsListSearchSchema,
  component: () => <Outlet />,
})
